import React from 'react';
import './EmailExpired.scss';
import { Link } from 'react-router-dom';

export default function EmailExpired() {
    return (
        <div className='emailExpired-container'>
                <div className="container grid md:grid-cols-2 grid-cols-1 justify-items-center items-center gap-5 p-5 mx-auto my-auto h-full">
                <div className='grid grid-cols-1 gap-6'>
                    <img src='/assets/logo/logo.png' className='object-contain h-8' alt='logo' />
                    <div>
                        <p className='font-bold text-[#2F2B3D] sm:text-5xl text-xl line'>Oops! Your email activation link is
                            expired or invalid</p>
                        <p className='my-4 text-base'>Please contact broker for further information</p>
                    </div>
                    <Link to={'/'} className=' text-center text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover sm:w-1/2'>Go to login
                    </Link>
                </div>
                <div>
                    <img src="/assets/images/emailExpired.png" alt="EMAIL" className='w-[40rem] p-4' />
                </div>
            </div>
        </div>
    )
}